import { toast } from "react-toastify";
import { call, put, takeLatest } from "redux-saga/effects";
import * as actions from "./Actions";
import * as api from "./Api";
import Types from "./Types";

function* getAllEnrollCourse({ payload }) {
  try {
    yield put(actions.addCourseLoading(true));
    const result = yield call(api.getEnrolledCourses, payload);
    yield put(actions.getEnrolledCoursesSuccess(result.data));
  } catch (error) {
    toast.error(error);
    yield put(actions.getEnrolledCoursesFail());
  } finally {
    yield put(actions.addCourseLoading(false));
  }
}
function* getAllPendingCourse({ payload }) {
  try {
    yield put(actions.addCourseLoading(true));
    const result = yield call(api.getPendingCourses, payload);
    yield put(actions.getPendingCoursesSuccess(result.data));
  } catch (error) {
    toast.error(error);
    yield put(actions.getPendingCoursesFail());
  } finally {
    yield put(actions.addCourseLoading(false));
  }
}
function* enrollCourse({ payload }) {
  try {
    yield put(actions.addCourseLoading(true));
    const result = yield call(api.enrolledCourse, payload);
    yield put(actions.enrolledCourseSuccess(result.data));
    payload.success && payload?.success();
  } catch (error) {
    toast.error(error?.response?.data?.message);
    yield put(actions.enrolledCourseFail());
  } finally {
    yield put(actions.addCourseLoading(false));
  }
}
export default function* StudentCourseSaga() {
  yield takeLatest(Types.GET_ENROLLED_COURSES_REQUEST, getAllEnrollCourse);
  yield takeLatest(Types.GET_PENDING_COURSES_REQUEST, getAllPendingCourse);

  yield takeLatest(Types.ENROLLED_COURSE_REQUEST, enrollCourse);
}
